export default __webpack_public_path__ + "static/media/oxopolitics-mono.c4efd138.svg";